/**
 * <p-cart-savings> — „Du sparst X ▾“ im Cart-Drawer-Fuß (snippets/p-cart-summary.liquid).
 * Der Button klappt die Aufschlüsselung (Reduzierte Preise + Shopify-Rabatte) auf und zu (aria-expanded).
 * Die Animation macht CSS (grid-template-rows 0fr → 1fr), hier wird nur der Zustand gesetzt.
 *
 * Re-Render des Drawers (Menge ändern, Artikel entfernen): Host und Button tragen im Liquid
 * data-skip-node-update, damit Theme Morph ihre Attribute (open / aria-expanded) stehen lässt
 * und nur den Inhalt (Beträge, Zeilen) aktualisiert. Wird das Element neu eingesetzt, übernimmt es
 * den zuletzt gewählten Zustand.
 */
let lastOpen = false;

class PCartSavings extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.#setOpen(lastOpen);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  get #toggle() {
    return this.querySelector('[data-p-savings-toggle]');
  }

  /** @param {boolean} open */
  #setOpen(open) {
    this.toggleAttribute('open', open);
    this.#toggle?.setAttribute('aria-expanded', String(open));
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const target = /** @type {Element} */ (event.target);
    if (!target.closest('[data-p-savings-toggle]')) return;
    event.preventDefault();
    lastOpen = !this.hasAttribute('open');
    this.#setOpen(lastOpen);
  };
}

if (!customElements.get('p-cart-savings')) {
  customElements.define('p-cart-savings', PCartSavings);
}
